// src/components/ThemeToggle.jsx
//
// Light/dark switch for the sidebar footer. Light is the default theme; this lets
// a user pick dark (remembered per browser). It renders nothing on the 'legacy'
// preview theme, which is not a user-facing choice.
import { useEffect, useState } from 'react'
import { Sun, Moon } from 'lucide-react'
import { T, getTheme, applyTheme, subscribeTheme } from '../theme/theme'

export default function ThemeToggle() {
  const [theme, setThemeState] = useState(getTheme)
  useEffect(() => subscribeTheme(setThemeState), [])

  if (theme === 'legacy') return null

  const next = theme === 'dark' ? 'light' : 'dark'
  const Icon = theme === 'dark' ? Sun : Moon
  return (
    <button
      type="button"
      onClick={() => applyTheme(next)}
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      style={{
        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
        padding: '8px', marginBottom: '8px', borderRadius: '8px',
        border: `1px solid ${T.bd}`, background: 'transparent', color: T.lt,
        fontSize: '13px', fontWeight: 500, cursor: 'pointer',
        fontFamily: "'Outfit',sans-serif", transition: 'all 0.15s',
      }}
    >
      <Icon size={15} strokeWidth={2} />
      {theme === 'dark' ? 'Light theme' : 'Dark theme'}
    </button>
  )
}
